module.exports = __webpack_public_path__ + "img/off_encajonadora.0752f0d4.png";